import styled from "styled-components";

export const OtpInput = styled.input`
  border: 0;
  outline: none;
  color: ${(props) => (props.isoemaps ? "rgb(139, 110, 73)"  : "#032146")} ;
  width: 20%;
  background-color: transparent;
  margin-left: 4px;
  text-align: center;
  font-size:  18px;
  &:focus {
    outline: 0;
    background: transparent;
  };
  ::placeholder{
    color:${(props) => (props.isoemaps ? "rgb(139, 110, 73)"  : "#bababa")};
    font-size:40px;
    
    
    
  }
  
`;

export const OtpInputWrapper = styled.div`
  width: 100%;
  display: flex;
  margin: 7% 0 3% 0;
`;


export const maxCharRestriction = (ref, maxLength) => {
    let target = ref.current.value.toString();
    ref.current.value = target.slice(0, maxLength);
};

export const onlyNumberInput = (ref) => {
    let value = ref.current.value
        .replace(/[^0-9]/g, "");
    return value;
};

export const onlyNumberOrTextInput = (ref) => {
    let value = ref.current.value.replace(/[^A-Za-z0-9]/g, "");
    return value;
}

export const validateMobileNumber = (ref) => {
    let numbers = /^[0-9]+$/;
    let mobileNo = ref.current ? ref.current.value : "";
    if (mobileNo.match(numbers)) {
        return true;
    } else {
        return false;
    }
};